export default __webpack_public_path__ + "static/media/user_no_image.ee8e2379.png";